import React from 'react'
import { Link } from 'react-router-dom'
import './HomeCatalogos.scss'

export const HomeCatalogos = () => {

    return (
        <div className="home-catalogos-container">
            <div className="home-catalogos-content">
                <div className="left">
                    <div className="text"><p>Todos los estilos, los colores, los tamaños y los materiales para llenar de <span className="letra">verde tu vida.</span></p></div>
                    <div className="botones">
                        <div className="btn"><p><Link to="/catalogos">VER CATÁLOGOS</Link></p></div>
                    </div>
                </div>
                <div className="right">
                    <div className="img">
                        <img src="./static/img/background-catalogos-home.jpg" alt="" />
                    </div>
                </div>
            </div>
        </div>
    )
}